import BrokerCreationTemplate from "./BrokerCreationTemplate";
import PersonSelect from "./PersonSelect";
import Disabled from "components/common/Disabled";
import {
  SURPLUS_BROKER_API_NAME,
  useGetSortedBrokerList,
  useGetSortedBrokerListWithRefresh,
} from "components/inputs/program/BrokerSupport";
import * as labels from "config.labels";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as peopleSelectors from "store/selectors/people/peopleSelectors";

const SurplusBrokerCreation = ({ onCreate, onClose }) => {
  const brokers = useGetSortedBrokerList(SURPLUS_BROKER_API_NAME);

  const [createBroker] = staticDataService.useCreateSurplusBrokerMutation();

  return (
    <BrokerCreationTemplate
      brokers={brokers}
      createBroker={createBroker}
      visibilityBaseTag={"<SurplusBrokerCreation>"}
      defaultVisibilityOverrideById={{
        name: true,
        email: false,
        workNumber: false,
        mobileNumber: false,
        company: true,
        address: false,
        licenseNumber: true,
        npn: true,
        location: false,
      }}
      formId={"surplus-broker-creation-form"}
      title={"Add a new surplus lines broker"}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const SurplusBroker = () => {
  const dispatch = useDispatch();

  const broker = useSelector(peopleSelectors.selectSurplusBroker);

  const updateBroker = (value) => {
    dispatch(peopleActions.updateSurplusBroker(value));
  };

  const [sortedBrokers, refreshBrokers] = useGetSortedBrokerListWithRefresh(
    SURPLUS_BROKER_API_NAME
  );

  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  return (
    <Disabled ifReadOnly>
      <PersonSelect
        person={broker}
        personList={sortedBrokers}
        onUpdatePerson={updateBroker}
        onUpdatePersonList={refreshBrokers}
        PersonCreationComponent={SurplusBrokerCreation}
        label={translateLabel(labels.SURPLUS_LINES_BROKER_TITLE, {
          default: "Surplus Lines Broker",
        })}
        showLabelOnCard
        showLicenseNumber
        searchProps={{
          showLicenseNumber: true,
        }}
      />
    </Disabled>
  );
};

export default SurplusBroker;
